class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.init();
  }

  init() {
    const headerRow = this.querySelector('summary');
    headerRow.addEventListener('click', this.onSummaryClick.bind(this));
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onSummaryClick(event) {
    event.preventDefault();
  }

  onMouseEnter() {
    clearTimeout(this.closeTimer);
    if (this.mainDetailsToggle.classList.contains('closing')) {
      this.mainDetailsToggle.classList.remove('closing');
      this.mainDetailsToggle.querySelector('.mega-menu__content').classList.remove('mega-menu__content--closing');
    }

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
    }
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    this.closeTimer = setTimeout(() => {
      this.close();
    }, 300);
  }

  close() {
    const content = this.mainDetailsToggle.querySelector('.mega-menu__content');
    this.mainDetailsToggle.classList.add('closing');
    content.classList.add('mega-menu__content--closing');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);

    const finishClosing = () => {
      if (this.mainDetailsToggle.classList.contains('closing')) {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.classList.remove('closing');
        content.classList.remove('mega-menu__content--closing');
      }
      content.removeEventListener('animationend', finishClosing);
    };

    content.addEventListener('animationend', finishClosing);
  }

  onToggle() {
    super.onToggle();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
